<template>
  <div class="transaction">
    <b-row class="mb-2">
      <b-col cols="4" class="header">
        <div class="text-header">จัดการการจอง</div>
        <b-button
          class="button-view"
          :class="{ active: view == 1 }"
          @click="changeView(1)"
        >
          <font-awesome-icon :icon="['fas', 'list-ul']" />
        </b-button>
        <b-button
          class="button-view"
          :class="{ active: view == 2 }"
          @click="changeView(2)"
        >
          <font-awesome-icon :icon="['fas', 'calendar-alt']" />
        </b-button>
      </b-col>
      <b-col cols="8">
        <div class="tw-flex tw-w-full">
          <div class="g-form">
            <div class="input">
              <b-form-input
                v-model="filter.keyword"
                placeholder="ค้นหา ชื่อ, เบอร์โทร, หมายเลขการจอง"
                @focus="iconSearch = true"
                @blur="iconSearch = false"
                @keyup.enter="getTransaction"
              ></b-form-input>
              <b-button
                class="search"
                :class="iconSearch ? 'active-border' : ''"
                @click="getTransaction"
              >
                <b-icon
                  stacked
                  icon="search"
                  scale="0.5"
                  variant="grey"
                ></b-icon>
              </b-button>
            </div>
          </div>

          <b-button class="btn-filter ml-2" @click="openSideBar">
            <span class="d-none d-md-block">
              <font-awesome-icon icon="filter" class="pointer" />
              <span class="btn-text">ตัวกรอง</span>
            </span>
          </b-button>

          <b-dropdown text="ดาวน์โหลดข้อมูล" right class="ml-2">
            <b-dropdown-item
              v-for="(item, index) in optionExport"
              :key="index"
              @click="onClickExportTransaction(item)"
            >
              {{ item.name }}
            </b-dropdown-item>
          </b-dropdown>

          <b-button
            class="btn-filter ml-2"
            @click="handleClickCreateTransaction"
            v-if="$isEventGroup && visibleBtnCreate"
          >
            <span class="d-none d-md-block">
              <span class="">สร้าง</span>
            </span>
          </b-button>
        </div>
      </b-col>
    </b-row>

    <SideBarFilter
      :filter="filter.filter"
      ref="sidebarFilter"
      placeholder="Booking"
      @searchAll="searchAll"
      @clearFilter="clearFilter"
      :hideStatusFilter="false"
      :hideSearchBar="true"
    >
      <template v-slot:filter-option>
        <div class="my-3">
          <InputText
            v-model="filter.keyword"
            textFloat="ค้นหา"
            placeholder="ค้นหา ชื่อ, เบอร์โทร, หมายเลขการจอง"
            type="text"
            name="text"
          >
            <template v-slot:option-first>
              <b-form-select-option value="" disabled
                >-- Select Status --</b-form-select-option
              >
              <b-form-select-option :value="null"
                >ทั้งหมด
              </b-form-select-option>
            </template></InputText
          >
        </div>
        <div class="mt-3 mb-3" v-if="$isEventGroup !== true">
          <InputSelect
            v-model="filter.filter.statusId"
            :options="optionsStatus"
            title="สถานะ"
            class="mt-2"
            valueField="transactionStatusId"
            textField="name"
          >
            <template v-slot:option-first>
              <b-form-select-option value="" disabled
                >-- เลือกสถานะ --</b-form-select-option
              >
              <b-form-select-option :value="null"
                >ทั้งหมด
              </b-form-select-option>
            </template></InputSelect
          >
        </div>
        <div class="mt-3 mb-3" v-else>
          <InputSelect
            v-model="filter.filter.customerStatusFlowId"
            :options="optionsCustomerFlowStatus"
            title="สถานะ"
            class="mt-2"
            valueField="id"
            textField="name"
          />
        </div>
        <div class="mt-3 mb-3">
          <InputSelect
            v-model="filter.filter.paymentTypeId"
            :options="optionsPayment"
            title="ช่องทางการโอนเงิน"
            class="mt-2"
            valueField="paymentTypeId"
            textField="name"
          />
        </div>
        <div class="d-flex">
          <div class="mb-3">
            <div class="label mb-2">วันที่สร้างเริ่มต้น</div>
            <div :class="['input-container']">
              <datetime
                v-model="filter.filter.createdTime.startTime"
                :input-style="styleDatetime"
                format="dd/MM/yyyy"
                value-zone="local"
                placeholder="เลือกวันที่"
                ref="createStartDate"
                :max-datetime="maxDate"
              >
              </datetime>
              <div
                class="icon-primary text-right"
                @click="$refs.createStartDate.isOpen = true"
              >
                <font-awesome-icon
                  icon="calendar-alt"
                  class="pointer g-text-gold"
                  color="#B41BB4"
                />
              </div>
            </div>
          </div>
          <div class="mx-1"></div>
          <div class="mb-3">
            <div class="label mb-2">วันที่สร้างสิ้นสุด</div>
            <div :class="['input-container']">
              <datetime
                v-model="filter.filter.createdTime.endTime"
                :input-style="styleDatetime"
                format="dd/MM/yyyy"
                value-zone="local"
                placeholder="เลือกวันที่"
                ref="createEndDate"
                :disabled="!filter.filter.createdTime.startTime"
                :min-datetime="minDateCreate"
              >
              </datetime>
              <div
                class="icon-primary text-right"
                @click="$refs.createEndDate.isOpen = true"
              >
                <font-awesome-icon
                  icon="calendar-alt"
                  class="pointer g-text-gold"
                  color="#B41BB4"
                />
              </div>
            </div>
            <p
              class="text-error"
              v-if="$v.filter.filter.createdTime.endTime.$error"
            >
              กรุณาเลือก
            </p>
          </div>
        </div>

        <div class="d-flex" v-if="$isEventGroup !== true">
          <div class="mb-3">
            <div class="label mb-2">วันที่ชำระเงินเริ่มต้น</div>
            <div :class="['input-container']">
              <datetime
                v-model="filter.filter.paymentTime.startTime"
                :input-style="styleDatetime"
                format="dd/MM/yyyy"
                value-zone="local"
                placeholder="เลือกวันที่"
                ref="paymentStart"
                :max-datetime="maxDate"
              >
              </datetime>
              <div
                class="icon-primary text-right"
                @click="$refs.paymentStart.isOpen = true"
              >
                <font-awesome-icon
                  icon="calendar-alt"
                  class="pointer g-text-gold"
                  color="#B41BB4"
                />
              </div>
            </div>
          </div>
          <div class="mx-1"></div>
          <div class="mb-3">
            <div class="label mb-2">วันที่ชำระเงินสิ้นสุด</div>
            <div :class="['input-container']">
              <datetime
                v-model="filter.filter.paymentTime.endTime"
                :input-style="styleDatetime"
                format="dd/MM/yyyy"
                value-zone="local"
                placeholder="เลือกวันที่"
                ref="paymentEndDate"
                :disabled="!filter.filter.paymentTime.startTime"
                :max-datetime="maxDate"
                :min-datetime="minDatePayment"
              >
              </datetime>
              <div
                class="icon-primary text-right"
                @click="$refs.paymentEndDate.isOpen = true"
              >
                <font-awesome-icon
                  icon="calendar-alt"
                  class="pointer g-text-gold"
                  color="#B41BB4"
                />
              </div>
            </div>
            <p
              class="text-error"
              v-if="$v.filter.filter.paymentTime.endTime.$error"
            >
              กรุณาเลือก
            </p>
          </div>
        </div>
        <div class="flex" v-if="view == 1">
          <div class="mb-3">
            <div class="label mb-2">รอบวันที่ + เวลาเริ่มต้น</div>
            <div :class="['input-container']">
              <datetime
                type="datetime"
                v-model="filter.filter.bookingDate.startTime"
                :input-style="styleDatetime"
                format="dd/MM/yyyy HH:mm:ss"
                value-zone="Asia/Bangkok"
                placeholder="เลือกวันที่"
                ref="bookingDateStart"
                :phrases="{ ok: 'Continue', cancel: 'Exit' }"
                use24-hour
              >
              </datetime>
              <div
                class="icon-primary text-right"
                @click="$refs.bookingDateStart.isOpen = true"
              >
                <font-awesome-icon
                  icon="calendar-alt"
                  class="pointer g-text-gold"
                  color="#B41BB4"
                />
              </div>
            </div>
          </div>
          <div class="mx-1"></div>
          <div class="mb-3">
            <div class="label mb-2">รอบวันที่ + เวลาสิ้นสุด</div>
            <div :class="['input-container']">
              <datetime
                type="datetime"
                v-model="filter.filter.bookingDate.endTime"
                :input-style="styleDatetime"
                format="dd/MM/yyyy HH:mm:ss"
                value-zone="Asia/Bangkok"
                placeholder="เลือกวันที่"
                ref="bookingDateEndDate"
                :disabled="!filter.filter.bookingDate.startTime"
                :phrases="{ ok: 'Continue', cancel: 'Exit' }"
                use24-hour
                :min-datetime="minDateBooking"
              >
              </datetime>
              <div
                class="icon-primary text-right"
                @click="$refs.bookingDateEndDate.isOpen = true"
              >
                <font-awesome-icon
                  icon="calendar-alt"
                  class="pointer g-text-gold"
                  color="#B41BB4"
                />
              </div>
            </div>
            <p
              class="text-error"
              v-if="$v.filter.filter.bookingDate.endTime.$error"
            >
              กรุณาเลือก
            </p>
          </div>
        </div>
        <div>
          <div v-if="$isEventGroup !== true">
            <AutocompleteCustom
              v-model="filter.filter.eventId"
              ref="AutocompleteCustom"
              id="eventId"
              label="บริการ"
              placeholder="บริการ"
              dataListID="dataListID"
              valueField="eventId"
              showValue=""
              :optionsList="optionsEvent"
              absolute
              @handleInput="handleInput"
            />
          </div>
          <div v-else>
            <div class="mt-2">
              <AutocompleteCustom
                v-model="filter.filter.eventGroupId"
                ref="AutocompleteCustomEventGroup"
                id="serviceId"
                label="บริการ"
                placeholder="บริการ"
                dataListID="dataListID"
                valueField="id"
                showValue=""
                :optionsList="optionEventGroup"
                :showValue="filter.filter.eventGroupId"
                absolute
                @handleInput="handleInput"
              />
            </div>
            <div class="mt-2">
              <AutocompleteCustom
                v-model="filter.filter.brandId"
                ref="AutocompleteCustomBrand"
                id="brandId"
                label="แบรนด์"
                placeholder="แบรนด์"
                dataListID="dataListID"
                valueField="id"
                :showValue="filter.filter.brandId"
                :optionsList="optionBrand"
                absolute
                @handleInput="handleInputBrand"
              />
            </div>
            <div class="mt-2">
              <AutocompleteCustom
                v-model="filter.filter.venueId"
                ref="AutocompleteCustomVenue"
                id="venueId"
                label="สาขา"
                placeholder="สาขา"
                dataListID="dataListID"
                valueField="id"
                :showValue="filter.filter.venueId"
                absolute
                :optionsList="optionVenue"
                @handleInput="handleInputVenue"
              />
            </div>
          </div>
        </div>
      </template>
    </SideBarFilter>

    <template v-if="view == 1">
      <Table
        :items="items"
        :fields="fields"
        :isBusy="isBusy"
        :rows="rows"
        :filter="filter"
        :pageOptions="pageOptions"
        @filterPage="filterPage"
        @getPaymentInfo="getPaymentInfo"
        @getTransaction="getTransaction"
      />
      <ModalConfirmPayment
        :dataPayment="dataPayment"
        @confirmSuccess="confirmSuccess"
      />
    </template>

    <template v-else>
      <Calendar
        ref="calendarView"
        :items="calendarItems"
        @getTransaction="getTransaction"
        @changeViewRange="changeViewRange"
      ></Calendar>
    </template>
  </div>
</template>

<script>
import Table from "./component/Table.vue";
import Calendar from "./component/Calendar.vue";
import ModalConfirmPayment from "@/components/modal/ModalConfirmPayment.vue";
import AutocompleteCustom from "@/components/inputs/AutocompleteCustom";
import * as moment from "moment/moment";
import { required, requiredIf } from "vuelidate/lib/validators";
import { mapGetters } from "vuex";

export default {
  components: {
    Table,
    ModalConfirmPayment,
    AutocompleteCustom,
    Calendar,
  },
  data() {
    return {
      view: 1,
      // state
      filter: {
        filter: {
          customerStatusFlowId: null,
          statusId: undefined,
          paymentTypeId: null,
          eventId: undefined,
          eventGroupId: undefined,
          brandId: undefined,
          venueId: undefined,
          createdTime: {
            startTime: null,
            endTime: null,
          },
          paymentTime: {
            startTime: null,
            endTime: null,
          },
          bookingDate: {
            startTime: null,
            endTime: null,
          },
          isGetUnavailableSlot: false,
        },
        keyword: "",
        skip: 1,
        take: 10,
        page: 1,
      },

      // option export
      optionExport: [
        {
          id: 1,
          name: "Order",
          enpoint: "/Transaction/Export",
          fileName: "TransactionExport",
        },
      ],

      // options filter
      optionsStatus: [],
      optionsCustomerFlowStatus: [],
      optionsPayment: [],
      optionsEvent: [],
      optionEventGroup: [],
      optionBrand: [],
      optionVenue: [],

      // condition date
      maxDate: null,

      minDateCreate: null,
      minDatePayment: null,
      minDateBooking: null,

      // state modal
      dataPayment: null,

      // state table
      items: [],
      calendarItems: [],

      isBusy: false,
      rows: 0,
      pageOptions: [
        { value: 10, text: "10 / หน้า" },
        { value: 30, text: "30 / หน้า" },
        { value: 50, text: "50 / หน้า" },
        { value: 100, text: "100 / หน้า" },
      ],

      // state sidebar
      styleDatetime: {
        width: "100%",
        border: "none",
      },

      // state css
      iconSearch: false,

      // state delay
      isSearchEvent: null,

      levelCreateTransaction: 14,
    };
  },
  validations() {
    return {
      filter: {
        filter: {
          createdTime: {
            endTime: {
              required: requiredIf(() => {
                return this.filter.filter.createdTime.startTime;
              }),
            },
          },
          paymentTime: {
            endTime: {
              required: requiredIf(() => {
                return this.filter.filter.paymentTime.startTime;
              }),
            },
          },
          bookingDate: {
            endTime: {
              required: requiredIf(() => {
                return this.filter.filter.bookingDate.startTime;
              }),
            },
          },
        },
      },
    };
  },
  computed: {
    ...mapGetters(["getUserDetail"]),
    fields() {
      let fields = [
        {
          key: "transactionId",
          label: "Id",
          class: "w-100px text-nowrap",
        },
        {
          key: "invoiceNo",
          label: "หมายเลขการจอง",
          class: "w-100px text-nowrap",
        },
        {
          key: "eventGroupName",
          label: "บริการ",
          class: "w-100px text-nowrap",
        },
        {
          key: "bookingDate",
          label: "รอบ วันที่ + เวลา",
          class: "w-150 text-nowrap",
        },
        {
          key: "paymentTypeName",
          label: "ช่องทางการชำระเงิน",
          class: "w-100px text-nowrap",
        },
        {
          key: "statusName",
          label: "สถานะ",
          class: "w-150 text-nowrap",
        },
        {
          key: "confirmBy",
          label: "ยืนยันโดย",
          class: "w-150 text-nowrap",
        },
        {
          key: "brandName",
          label: "แบรนด์",
          class: "w-100px text-nowrap",
        },
        {
          key: "venueName",
          label: "สาขา",
          class: "w-100px text-nowrap",
        },
        {
          key: "promocodeSerialNo",
          label: "คูปอง",
          class: "w-100px text-nowrap",
        },
        {
          key: "grandTotal",
          label: "ราคาสุทธิ",
          class: "w-50px text-nowrap",
        },
        {
          key: "fullName",
          label: "ชื่อ นามสกุล",
          class: "w-100px text-nowrap",
        },
        {
          key: "email",
          label: "อีเมล",
          class: "w-150 text-nowrap",
        },
        {
          key: "telephone",
          label: "เบอร์โทร",
          class: "w-100px text-nowrap",
        },
        {
          key: "note",
          label: "หมายเหตุเพิ่มเติม",
          class: "w-150 text-nowrap",
        },
        {
          key: "createdTime",
          label: "วันที่สร้าง",
          class: "w-100px text-nowrap",
        },

        { key: "actions", label: "ดำเนินการ", class: "w-100px text-nowrap" },
      ];
      if (this.$isEventGroup !== true) {
        fields.push({
          key: "paymentTime",
          label: "วันที่ชำระเงิน",
          class: "w-100px text-nowrap",
        });
        return fields;
      } else {
        return fields;
      }
    },
    visibleBtnCreate() {
      return !!this.$store.state.permission.Permission.find(
        (e) => e.permissionMenuId === this.levelCreateTransaction
      );
    },
  },
  watch: {
    // "filter.filter.createdTime.startTime"(val) {
    //   if (val) {
    //     this.minDateCreate = new Date(val).toISOString();
    //     this.configFilter.createdTime.endTime = null;
    //   }
    // },
    // "filter.filter.paymentTime.startTime"(val) {
    //   if (val) {
    //     this.minDatePayment = new Date(val).toISOString();
    //     this.configFilter.paymentTime.endTime = null;
    //   }
    // },
    // "filter.filter.bookingDate.startTime"(val) {
    //   if (val) {
    //     this.minDateBooking = new Date(val).toISOString();
    //     // this.configFilter.bookingDate.endTime = null;
    //   }
    // },
  },
  mounted() {
    this.filter.filter.venueId = this.getUserDetail.defaultVenueId || undefined;
    this.searchAll();
    this.getStatusOption();
    this.getPaymentOption();
    this.maxDate = new Date().toISOString();
  },

  methods: {
    changeViewRange(range, date) {
      this.filter.filter.bookingDate.startTime = date.startTime;
      this.filter.filter.bookingDate.endTime = date.endTime;
      this.$nextTick(() => {
        this.getTransaction();
      });
    },
    async changeView(view) {
      this.view = view;
      this.filter.filter.bookingDate.startTime =
        this.view == 1
          ? null
          : this.$moment().startOf("week").format("YYYY-MM-DD");
      this.filter.filter.bookingDate.endTime =
        this.view == 1
          ? null
          : this.$moment().endOf("week").format("YYYY-MM-DD");
      this.filter.page = 1;
      this.filter.filter.isGetUnavailableSlot = this.view == 1 ? false : true;
      this.$forceUpdate();
      this.$nextTick(() => {
        this.getTransaction();
      });
    },
    async onClickExportTransaction(v) {
      const baseFilter = this.filter.filter ?? {};
      const params = {
        ...this.filter,
        skip: this.view == 1 ? this.filter.skip : null,
        take: this.view == 1 ? this.filter.take : null,
        isEventGroup: this.$isEventGroup,
        filter: {
          ...baseFilter,
          bookingDate: this.hasDateValue(baseFilter.bookingDate),
          createdTime: this.hasDateValue(baseFilter.createdTime),
          paymentTime: this.hasDateValue(baseFilter.paymentTime),
        },
      };
      const getData =
        await this.$services.transaction.exportTransactionByFilter(
          v.enpoint,
          params
        );
      this.resolveAndDownloadBlob(getData, `${v.fileName}`);
    },
    hasDateValue(item) {
      if (Boolean(item.startTime && item.endTime)) return { ...item };
      return undefined;
    },
    async getTransaction() {
      this.isBusy = true;
      const baseFilter = this.filter.filter ?? {};
      const params = {
        ...this.filter,
        skip: this.view == 1 ? this.filter.skip : null,
        take: this.view == 1 ? this.filter.take : null,
        isEventGroup: this.$isEventGroup,
        filter: {
          ...baseFilter,
          bookingDate: this.hasDateValue(baseFilter.bookingDate),
          createdTime: this.hasDateValue(baseFilter.createdTime),
          paymentTime: this.hasDateValue(baseFilter.paymentTime),
        },
      };

      const getData = await this.$services.transaction.getTransactionList(
        params
      );

      if (getData.result == 1) {
        this.items = getData.detail.data;
        this.rows = getData.detail.count;
        this.calendarItems = (getData.detail.data).concat(getData.detail.listUnavailableData).map((item) => ({
          id: item.refId ?? 'unavialable',
          title: item.eventName,
          start: item.calendarStartTime,
          end: item.calendarEndTime,
          extendedProps: {
            calendarPrimaryColor: item.calendarPrimaryColor,
            calendarSecondaryColor: item.calendarSecondaryColor,
            fullName: `${item.firstname} ${item.lastname?.charAt(0)}. `,
            calendarProductDisplay: item.calendarProductDisplay,
          },
        }))
      } else {
        this.$cookies.remove("back_office_admin_sale_order_token");
        this.$router.replace("/");
      }

      this.isBusy = false;
    },
    async getPaymentInfo(refId) {
      const getData = await this.$services.transaction.getPaymentInfo(refId);

      if (getData.result == 1) {
        // add state base64

        getData.detail.bankTransferList = getData.detail.bankTransferList.map(
          (x) => {
            // change format dateonly

            x.transactionDetail.dateOnly = x.transactionDetail.dateOnly
              .split("-")
              .reverse()
              .join("-");

            // add new key to obj

            let obj = {
              ...x,
              base64: {
                base64: null,
              },
              imageName: x.transactionDetail.slipImgUrl.split("/").reverse()[0],
            };

            // conver time

            x.transactionDetail.timeOnly = this.convertTime(
              x.transactionDetail.timeOnly
            );

            return obj;
          }
        );

        getData.detail.refId = refId;

        this.dataPayment = getData.detail;

        this.$bvModal.show("modal-confirm-payment");
      }
    },
    async getStatusOption() {
      if (this.$isEventGroup === true) {
        const customerStatusFlowData =
          await this.$services.master.getOptionCustomerStatusFlow();
        if (customerStatusFlowData.result === 1) {
          this.optionsCustomerFlowStatus = [
            {
              name: "ทั้งหมด",
              id: null,
            },
            ...customerStatusFlowData.detail,
          ];
        }
      } else {
        const getData = await this.$services.master.getStatusOption();

        if (getData.result == 1) {
          this.optionsStatus = [
            {
              name: "ทั้งหมด",
              transactionStatusId: null,
            },
            ...getData.detail,
          ];
        }
      }
    },
    async getPaymentOption() {
      const getData = await this.$services.master.getPaymentOption();

      if (getData.result == 1) {
        this.optionsPayment = [
          {
            name: "ทั้งหมด",
            transactionStatusId: null,
          },
          ...getData.detail,
        ];
      }
    },
    async getOptionBrand(keyword) {
      const brandData = await this.$services.master.getOptionBrand(keyword);
      if (brandData.result === 1) {
        const allOption = [{ id: undefined, name: "ทั้งหมด" }];
        this.optionBrand = allOption.concat(brandData.detail);
      }
    },
    async getOptionVenue(keyword) {
      const venueData = await this.$services.master.getOptionVenue(keyword);
      if (venueData.result === 1) {
        const allOption = [{ id: undefined, name: "ทั้งหมด" }];
        this.optionVenue = allOption.concat(venueData.detail);
      }
    },
    async getEventOption(keyword) {
      const check = Number(keyword) ? true : false;
      const allOption = [{ id: undefined, name: "ทั้งหมด" }];
      if (check) {
        return;
      }

      if (this.$isEventGroup === false) {
        const getData = await this.$services.master.getEventOption(keyword);

        if (getData.result == 1) {
          this.optionsEvent = allOption.concat(getData.detail);
        }
      } else {
        const eventGroupData = await this.$services.master.getOptionEventGroup(
          keyword
        );
        if (eventGroupData.result === 1) {
          this.optionEventGroup = allOption.concat(eventGroupData.detail);
        }
      }
    },
    handleClickCreateTransaction() {
      this.$router.push("/transaction/create");
    },
    handleInput(val) {
      if (this.isSearchEvent) {
        clearTimeout(this.isSearchEvent);
      }

      this.isSearchEvent = setTimeout(() => {
        this.getEventOption(val);
      }, 1000);
    },
    handleInputBrand(val) {
      if (this.isSearchEvent) {
        clearTimeout(this.isSearchEvent);
      }

      this.isSearchEvent = setTimeout(() => {
        this.getOptionBrand(val);
      }, 1000);
    },
    handleInputVenue(val) {
      if (this.isSearchEvent) {
        clearTimeout(this.isSearchEvent);
      }

      this.isSearchEvent = setTimeout(() => {
        this.getOptionVenue(val);
      }, 1000);
    },
    confirmSuccess() {
      this.getTransaction();
    },
    filterPage(obj) {
      this.filter.skip = obj.page;
      this.getTransaction();
    },
    openSideBar() {
      this.$refs.sidebarFilter.show();
      this.getEventOption();
      if (this.$isEventGroup === true) {
        this.getOptionBrand();
        this.getOptionVenue();
      }
    },
    searchAll() {
      this.$v.filter.filter.$touch();

      if (this.$v.filter.filter.$error) {
        return;
      }

      this.$refs.sidebarFilter.hide();

      this.getTransaction();
    },

    convertTime(time) {
      let getTime = `${this.$moment().format("YYYY-MM-DDT")}${time}`;

      return getTime;
    },

    convertTimeHHMM(time) {
      return this.$moment(time).format("HH:mm");
    },

    clearFilter() {
      // clear validate
      this.$v.filter.filter.$reset();
      this.filter = {
        filter: {
          statusId: null,
          paymentTypeId: null,
          customerStatusFlowId: null,
          eventId: undefined,
          brandId: undefined,
          venueId: undefined,
          eventGroupId: undefined,
          createdTime: {
            startTime: null,
            endTime: null,
          },
          paymentTime: {
            startTime: null,
            endTime: null,
          },
          bookingDate: {
            startTime: null,
            endTime: null,
          },
          isGetUnavailableSlot: this.view == 1 ? false : true,
        },
        keyword: "",
        skip: 1,
        page: 1,
        take: 10,
      };

      this.clearInputs();
      this.$refs.sidebarFilter.hide();
      this.$forceUpdate();

      this.$nextTick(() => {
        if (this.view === 2) this.$refs.calendarView.clearFilter();
        else this.getTransaction();
      });
    },
    resolveAndDownloadBlob(v, filename) {
      return this.$services.utils.resolveAndDownloadBlob(v, filename);
    },
    clearInputs() {
      if (this.$isEventGroup === true) {
        this.$refs.AutocompleteCustomEventGroup.clearInput();
        this.$refs.AutocompleteCustomVenue.clearInput();
        this.$refs.AutocompleteCustomBrand.clearInput();
      } else {
        this.$refs.AutocompleteCustom.clearInput();
      }
    },
  },
};
</script>

<style lang="scss" scoped>
.transaction {
  .text-header {
    color: #092d53;
    font-weight: 600;
    font-size: 20px;
    text-transform: uppercase;
  }

  .header {
    display: flex;
    gap: 8px;
    align-items: center;
  }

  .button-view {
    border-radius: 50%;
    width: 36px;
    height: 36px;
    display: flex;
    justify-content: center;
    align-items: center;
    padding: 0;

    &.active {
      background-color: var(--primary-color);
      color: white;
    }
  }
}
.text-error {
  margin: 0;
  color: red;
}
// ! override
.g-form {
  width: 100%;
}

::v-deep .btn-filter button,
.btn-filter {
  color: var(--primary-color) !important;
  border-color: var(--primary-color);
  font-weight: 100;
  min-width: 105px;
}

.year-month-wrapper {
  background-color: var(--primary-color) !important;
}
</style>
